import MinorButton from "@hudson/ui/components/FormFields/ButtonMinor";
import useContent from "@lib/use_content";

export default function Pagination({
  className = "",
  currentPage,
  loading,
  pageItemCount,
  totalItems = 500,
  totalPages,
  onPageChange,
}: {
  className?: string;
  currentPage: number;
  loading: boolean;
  pageItemCount: number;
  totalItems: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}) {
  const { data } = useContent(["bePaginationOf"]);

  const firstShownItem = pageItemCount * (currentPage - 1) + 1;
  const lastShownItem = pageItemCount * (currentPage - 1) + pageItemCount;

  return (
    <div className={`${className} flex justify-center align-middle gap-x-4`}>
      <MinorButton
        disabled={loading || currentPage === 1}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        }
        onClick={() => onPageChange(currentPage - 1)}
        padding="pl-2 pr-1 py-1"
      />
      <div className="text-sm">
        {loading || totalItems === 0 ? (
          "--"
        ) : (
          <>
            {firstShownItem} - {Math.min(totalItems, lastShownItem)}{" "}
            <span className="text-gray-500">{data?.content.bePaginationOf}</span> {totalItems}
          </>
        )}
      </div>

      <MinorButton
        disabled={loading || currentPage === totalPages}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        }
        onClick={() => onPageChange(currentPage + 1)}
        padding="pl-2 pr-1 py-1"
      />
    </div>
  );
}
